module.exports = __webpack_public_path__ + "img/windmill-2.9e99cda0.png";